<template>
  <div class="lxm-contact-contact-attachment">
    <div class="page">
      <transition name="lxm-content-transition" mode="out-in">
        <lxm-panel v-if="!loading" :rows="rows"></lxm-panel>
      </transition>
    </div>
  </div>
</template>

<style lang="stylus">
  @import '../../../styles/variables.styl'
  // .lxm-contact-contact-attachment
</style>

<script>
  import LxmPanel from '../../common/LxmPanel.vue'
  import * as aTypes from '../../../../store/action-types'
  import * as mTypes from '../../../../store/mutation-types'
  export default {
    components: {
      LxmPanel
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_ATTACHMENTS, this.$route.query.contactId)
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT_ATTACHMENTS]
      },
      state () {
        return this.$store.state.contact.attachment
      },
      rows () {
        return this.state.list
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Attachment.vue?39722d4b